import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import LinksPreview from './Links/index.js';
import ProductsPreview from './Products/index.js';
import SignupPreview from './Signup/index.js';
import TextPreview from './Text/index.js';
import Wrapper from './Wrapper/index.js';
import VcardPreview from './Vcard/index.js';
import { OFFER_TYPE_PROP_TYPES, NEWSLETTERS_SIGNUP_SECTION, TEXT_SECTION, LINKS_SECTION, PRODUCTS_SECTION, VCARD_BLOCK_SECTION, OFFER_TYPES, SIGNUP_TYPE, CONSOLIDATED_SECTION, SIGNUP_SECTION, PAYMENT_TYPE, LANDING_PAGES } from './utils/constants/offers.js';
import styles from './ThemePreview.module.scss.js';

var ThemePreview = function ThemePreview(_ref) {
  var _blockComponents;
  var contributionLanguage = _ref.contributionLanguage,
    getCustomText = _ref.getCustomText,
    _ref$isThemePreview = _ref.isThemePreview,
    isThemePreview = _ref$isThemePreview === void 0 ? false : _ref$isThemePreview,
    richMediaUrls = _ref.richMediaUrls,
    socialLinks = _ref.socialLinks,
    rootCssVariables = _ref.rootCssVariables,
    products = _ref.products,
    TagsToRender = _ref.TagsToRender,
    themePreviewStyles = _ref.themePreviewStyles,
    toggledSelection = _ref.toggledSelection,
    values = _ref.values,
    isPageConsolidationEnabled = _ref.isPageConsolidationEnabled,
    _ref$values = _ref.values,
    _ref$values$blocks = _ref$values.blocks,
    _blocks = _ref$values$blocks === void 0 ? [] : _ref$values$blocks,
    brand_name = _ref$values.brand_name,
    _ref$values$collect_s = _ref$values.collect_signups,
    collect_signups = _ref$values$collect_s === void 0 ? true : _ref$values$collect_s,
    _ref$values$cover_pre = _ref$values.cover_preview,
    cover_preview = _ref$values$cover_pre === void 0 ? null : _ref$values$cover_pre,
    default_authentication_method = _ref$values.default_authentication_method,
    _ref$values$display_b = _ref$values.display_brand_name,
    display_brand_name = _ref$values$display_b === void 0 ? false : _ref$values$display_b,
    _ref$values$display_l = _ref$values.display_logo,
    display_logo = _ref$values$display_l === void 0 ? false : _ref$values$display_l,
    _ref$values$display_s = _ref$values.display_social_links,
    display_social_links = _ref$values$display_s === void 0 ? false : _ref$values$display_s,
    email_signup_method = _ref$values.email_signup_method,
    _ref$values$enable_co = _ref$values.enable_cover_image,
    enable_cover_image = _ref$values$enable_co === void 0 ? false : _ref$values$enable_co,
    _ref$values$fields = _ref$values.fields,
    fields = _ref$values$fields === void 0 ? [] : _ref$values$fields,
    _ref$values$newslette = _ref$values.newsletters,
    newsletters = _ref$values$newslette === void 0 ? {} : _ref$values$newslette,
    _ref$values$payment_r = _ref$values.payment_rich_text,
    payment_rich_text = _ref$values$payment_r === void 0 ? {} : _ref$values$payment_r,
    phone_signup_method = _ref$values.phone_signup_method,
    _ref$values$products = _ref$values.products,
    addedProducts = _ref$values$products === void 0 ? [] : _ref$values$products,
    _ref$values$signup_me = _ref$values.signup_methods,
    signup_methods = _ref$values$signup_me === void 0 ? {} : _ref$values$signup_me,
    _ref$values$signup_ri = _ref$values.signup_rich_text,
    signup_rich_text = _ref$values$signup_ri === void 0 ? {} : _ref$values$signup_ri,
    signup_subtitle = _ref$values.signup_subtitle,
    signup_title = _ref$values.signup_title,
    theme_id = _ref$values.theme_id,
    type = _ref$values.type;
  var blocks = [].concat(_blocks).sort(function (a, b) {
    return a.order - b.order;
  });
  var isPayment = toggledSelection === PAYMENT_TYPE;
  var blockComponents = (_blockComponents = {}, _blockComponents[NEWSLETTERS_SIGNUP_SECTION] = SignupPreview, _blockComponents[TEXT_SECTION] = TextPreview, _blockComponents[LINKS_SECTION] = LinksPreview, _blockComponents[PRODUCTS_SECTION] = ProductsPreview, _blockComponents[VCARD_BLOCK_SECTION] = VcardPreview, _blockComponents);
  var isPaymentLP = OFFER_TYPES(LANDING_PAGES.value).payment === type;

  // these keys are not linked to the signup block in the blocks array
  // so add them in manually
  var getSignupBlockMeta = function getSignupBlockMeta() {
    var checkedSignupMethods = Object.keys(signup_methods).filter(function (method) {
      return signup_methods[method];
    });
    var checkedNewsletters = ((newsletters === null || newsletters === void 0 ? void 0 : newsletters.options) || []).reduce(function (all, nl) {
      return [].concat(all, [Object.assign({}, nl, {
        enabled: true,
        disabled: true,
        type: 'free',
        name: nl.label
      })]);
    }, []);
    return {
      fields: fields,
      authenticationMethods: checkedSignupMethods,
      newsletters: checkedNewsletters,
      formTitle: signup_title,
      formSubtitle: signup_subtitle,
      email_signup_method: email_signup_method,
      phone_signup_method: phone_signup_method,
      default_authentication_method: default_authentication_method,
      brandName: brand_name
    };
  };

  // uses the block field in the blocks array and maps out the
  // data necessary to render each block depending on type
  var getBlockData = function getBlockData(block, type) {
    var data = block[type + "_block"];
    var blockData = data;
    switch (type) {
      case TEXT_SECTION:
        blockData = Object.assign({}, data, {
          draftJsValue: data.value,
          getCustomText: getCustomText,
          url: data.file_name
        });
        break;
      case PRODUCTS_SECTION:
        blockData = isPageConsolidationEnabled && !isPaymentLP ? Object.assign({}, data, {
          contributionLanguage: contributionLanguage,
          draftJsValue: payment_rich_text === null || payment_rich_text === void 0 ? void 0 : payment_rich_text.value,
          getCustomText: getCustomText,
          products: data.product ? [data.product] : []
        }) : Object.assign({}, data, {
          addedProducts: addedProducts,
          contributionLanguage: contributionLanguage,
          draftJsValue: payment_rich_text === null || payment_rich_text === void 0 ? void 0 : payment_rich_text.value,
          getCustomText: getCustomText,
          products: products
        });
        break;
      case SIGNUP_SECTION:
        var _type = NEWSLETTERS_SIGNUP_SECTION;
        blockData = Object.assign({}, data, getSignupBlockMeta(), {
          draftJsValue: signup_rich_text === null || signup_rich_text === void 0 ? void 0 : signup_rich_text.value,
          getCustomText: getCustomText,
          isPayment: isPayment,
          isPaymentLP: isPaymentLP,
          signup_type: _type,
          type: SIGNUP_SECTION,
          theme_id: theme_id
        });
        break;
      case LINKS_SECTION:
        blockData = {
          linkBlock: data,
          richMediaUrls: richMediaUrls
        };
        break;
    }
    return blockData;
  };
  var previewContents = /*#__PURE__*/React.createElement(React.Fragment, null, blocks.map(function (block, idx) {
    if (block === void 0) {
      block = {};
    }
    var _block = block,
      type = _block.type,
      signup_block = _block.signup_block;
    if (type === SIGNUP_TYPE && [NEWSLETTERS_SIGNUP_SECTION, CONSOLIDATED_SECTION].includes(signup_block === null || signup_block === void 0 ? void 0 : signup_block.type) && !collect_signups) {
      return null;
    }
    if ([VCARD_BLOCK_SECTION, TEXT_SECTION].concat(isPayment ? [TEXT_SECTION, PRODUCTS_SECTION] : [LINKS_SECTION, SIGNUP_SECTION, isPageConsolidationEnabled && !isPaymentLP ? PRODUCTS_SECTION : '']).includes(type)) {
      var data = getBlockData(block, type);
      var BlockComponent = blockComponents[data.signup_type || type];
      return /*#__PURE__*/React.createElement("div", {
        className: styles.block
      }, /*#__PURE__*/React.createElement(BlockComponent, _extends({
        key: idx
      }, data, {
        isPageConsolidationEnabled: isPageConsolidationEnabled,
        isPaymentLP: isPaymentLP
      })));
    }
  }));
  var Preview = function Preview() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.preview,
      id: "preview"
    }, TagsToRender, /*#__PURE__*/React.createElement("style", null, rootCssVariables), /*#__PURE__*/React.createElement("style", null, "#preview #form .page {\n                    transition: all .5s ease;\n                }\n                #preview h1 span,\n                #preview h1 div,\n                #preview h2 span,\n                #preview h2 div,\n                #theme-preview #form h1 span,\n                #theme-preview #form h1 div,\n                #theme-preview #form h2 span,\n                #theme-preview #form h2 div {\n                    font-size: inherit !important;\n                }\n\n                #theme-preview #form .page {\n                    padding-bottom: 3rem;\n                }\n                \n                #preview .link-primary {\n                    color: inherit !important;\n                }"), isThemePreview && /*#__PURE__*/React.createElement("style", null, themePreviewStyles), /*#__PURE__*/React.createElement("div", {
      id: "form",
      className: styles.pageWrapper
    }, /*#__PURE__*/React.createElement(Wrapper, {
      imagePreview: enable_cover_image ? cover_preview : null,
      showBrandName: display_brand_name,
      showLogo: display_logo,
      showSocialLinks: display_social_links,
      socialLinks: socialLinks,
      values: values
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.pageContentWrapper
    }, previewContents))));
  };
  return /*#__PURE__*/React.createElement(Preview, null);
};
ThemePreview.propTypes = {
  account: PropTypes.object,
  blocks: PropTypes.object,
  brand_name: PropTypes.string,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  collect_signups: PropTypes.bool,
  contributionLanguage: PropTypes.string,
  cover_preview: PropTypes.string,
  default_authentication_method: PropTypes.string,
  display_brand_name: PropTypes.bool,
  display_logo: PropTypes.bool,
  display_social_links: PropTypes.bool,
  email_signup_method: PropTypes.bool,
  enable_cover_image: PropTypes.bool,
  fields: PropTypes.object,
  getCustomText: PropTypes.func,
  isPageConsolidationEnabled: PropTypes.bool,
  isThemePreview: PropTypes.bool,
  newsletters: PropTypes.object,
  OfferContext: PropTypes.object,
  payment_rich_text: PropTypes.object,
  phone_signup_method: PropTypes.bool,
  products: PropTypes.array,
  richMediaUrls: PropTypes.object,
  rootCssVariables: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  screenSize: PropTypes.oneOf(['desktop', 'mobile']),
  signup_methods: PropTypes.object,
  signup_rich_text: PropTypes.object,
  signup_subtitle: PropTypes.bool,
  signup_title: PropTypes.bool,
  socialLinks: PropTypes.object,
  TagsToRender: PropTypes.node,
  theme_id: PropTypes.string,
  themePreviewStyles: PropTypes.string,
  toggledSelection: PropTypes.oneOf(OFFER_TYPE_PROP_TYPES),
  values: PropTypes.object
};
var index = /*#__PURE__*/React.memo(ThemePreview);

export { index as default };
//# sourceMappingURL=index.js.map
